import { useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignIn from "./Pages/SignIn/SignIn";
import LdapSignIn from "./Pages/SignIn/LdapSignIn";
import Layout from "./Components/UI/Layout/Layout";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import ChangePassword from "./Pages/ChangePassword/ChangePassword";
import { useTheme } from "./utils/hook/useTheme";
import { loadFromLocalStorage } from "./utils/localStorage";
import AnalysisReportsWrapper from "./Pages/AnalysisReports/AnalysisReportsWrapper";
import RemoteConnection from "./Pages/RemoteConnection/RemoteConnection";
import ReportExport from "./Pages/ReportExport/ReportExport";
import ReportPDF from "./Components/PagesComponents/ReportExport/ReportPDF/ReportPDF";
import ThreatHunterReportExport from "./Pages/ThreatHunterReportExport/ThreatHunterReportExport";
import ThreatHunterReportPDF from "./Components/PagesComponents/ThreatHunterReportExport/ThreatHunterReportPDF/ThreatHunterReportPDF";
import AndroidReportExport from "./Pages/AndroidReportExport/AndroidReportExport";
import AndroidReportPDF from "./Components/PagesComponents/AndroidReportExport/AndroidReportPDF/AndroidReportPDF";
import { themeRequest } from "./store/actions/themeAction";
import Reports from "./Pages/Reports/Reports";
import Notifier from "./Components/common/Notifier/Notifier";
import { CssBaseline } from "@mui/material";
// import Settings from "./Pages/Settings/Settings";
import CustomScrollbar from "./Components/common/CustomScrollbar/CustomScrollbar";
import "./styles/main.scss";
import RunningAnalysis from "./Pages/RunningAnalysis/RunningAnalysis";
import UserProfile from "./Pages/UserProfile/UserProfile";
import ImapEmail from "./Pages/IntegratedAnalysis/ImapEmail/ImapEmail";
import Statistics from "./Pages/Statistics/Statistics";
import FileShare from "./Pages/IntegratedAnalysis/FileShare/FileShare";
import ProxyWeb from "./Pages/IntegratedAnalysis/ICAPweb/Icap";
import TapWeb from "./Pages/IntegratedAnalysis/TAPweb/Tap";
import Endpoint from "./Pages/IntegratedAnalysis/Endpoint/Endpoint";
import WinShare from "./Pages/IntegratedAnalysis/WinShare/WinShare";
import PostfixEmail from "./Pages/IntegratedAnalysis/PostfixEmail/PostfixEmail";
import Email from "./Pages/IntegratedAnalysis/UsbTransfer/UsbTransfer";
import { licenceCheckRequest } from "./store/actions/usersActions";
import SystemInfo from "./Pages/Licence/SystemInfo";
import IntegrationMarket from "./Pages/IntegrationMarket/IntegrationMarket";
import Footer from "./Components/UI/Footer/Footer";
import ErrorBoundary from "./Pages/ErrorPage/ErrorBoundary";
import UserAccounts from "./Pages/Settings/Content/Tabs/UserAccounts/UserAccounts";
import DataRetention from "./Pages/Settings/Content/Tabs/DataRetention/DataRetention";
import DumpAndRestore from "./Pages/Settings/Content/Tabs/DumpAndRestore/DumpAndRestore";
import PublicApi from "./Pages/Settings/Content/Tabs/PublicApi/PublicApi";
import OutlookAddIn from "./Pages/IntegratedAnalysis/OutlookAddIn/OutlookAddIn";
import NetworkDetections from "./Pages/IntegratedAnalysis/NetworkDetections/NetworkDetections";
import Urls from "./Pages/IOCs/Urls/Urls";
import DomainsAndIps from "./Pages/IOCs/DomainsAndIps/DomainsAndIps";
import Hashes from "./Pages/IOCs/Hashes/Hashes";
import IocDashboard from "./Pages/IOCs/Dashboard/IocDashboard";
import MailGatewayDashboard from "./Pages/MailGateway/Dashboard";
import AnalyzedEmails from "./Pages/MailGateway/AnalyzedEmails";
import BlockedEmails from "./Pages/MailGateway/BlockedEmails";
import UnblockedEmails from "./Pages/MailGateway/UnblockedEmails";
import TransferLogs from "./Pages/MailGateway/TransferLogs";
import Products from "./Pages/Products/Products";
import CloudLayout from "./CloudModel/CloudUI/CloudLayout/CloudLayout";
import CloudFooter from "./CloudModel/CloudUI/CloudFooter/CloudFooter";
import Login from "./CloudModel/CloudPages/Login/Login";
import SignUp from "./CloudModel/CloudPages/SignUp/SignUp";
import ForgotPW from "./CloudModel/CloudPages/ForgotPW/ForgotPW";
import Home from "./CloudModel/CloudPages/Home/Home";
import ApiDocu from "./Components/UI/ApiDocu/ApiDocu";
import Pricing from "./CloudModel/CloudPages/Pricing/Pricing";
import SubmissionList from "./CloudModel/CloudPages/SubmissionList/SubmissionList";
import ContainerServicesPage from "./Pages/Containers/ContainerServicesPage";
import CloudProfile from "./CloudModel/CloudUI/CloudProfile/CloudProfile";
import CustomSignatures from "./Pages/Settings/Content/Tabs/CustomSignatures/CustomSignatures";
import Logs from "./Pages/Logs/Logs";
import NewDash from "./Pages/NewDash/NewDash";
import LogWindow from "./Pages/Logs/components/LogWindow";
import { RequestBackendServiceConnected } from "./store/actions/containerActions";
import Backdrop from "./Components/UI/Backdrop/Backdrop";
import Cdr from "./Pages/IntegratedAnalysis/Cdr/Cdr";
import AgentStatus from "./Pages/Agents/AgentStatus/AgentStatus";
import AgentInstallation from "./Pages/Agents/AgentInstallation/AgentInstallation";
import Ldap from "./Pages/Settings/Content/Tabs/LDAP/Ldap";
import UpdateScheduler from "./Pages/Settings/Content/Tabs/UpdateScheduler/UpdateScheduler";
import DynamicPhishingEmails from "./Pages/MailGateway/DynamicPhishingEmails";
import PhishBox from "./Pages/PhishBox/PhishBox";
import PhishboxSettings from "./Pages/Settings/Content/Tabs/Phishbox/PhishboxSettings";
import LlmSettings from "./Pages/Settings/Content/Tabs/LLM/LlmSettings";
import HunterBox from "./Pages/HunterBox/HunterBox";
import WatermarkDecoder from "./Pages/WatermarkDecoder/WatermarkDecoder";
import CoreServers from "./Pages/Settings/Content/Tabs/CoreServers/CoreServers";
import Notifications from "./Pages/Settings/Content/Tabs/Notifications/Notifications";
import AutoSubmission from "./Pages/Settings/Content/Tabs/AutoSubmission/AutoSubmission";
import ThreatReports from "./Pages/Agents/ThreatReports/ThreatReports";
import ThreatHunterDashboard from "./Pages/Agents/ThreatHunterDashboard/ThreatHunterDashboard";
import YaraResults from "./Pages/Agents/YaraResults/YaraResults";
// import FsaCdr from "./Pages/FSA/Cdr/Cdr";
// import FsaApplications from "./Pages/FSA/Applications/FsaApplications";
// import ThreatHunterDetections from "./Pages/ThreatHunter/ThreatHunterDetections";

const ProtectedRoute = ({ isAllowed, redirectTo, component: Component, ...props }) => {
  // The guard must be evaluated *inside* the route, so a disallowed page only
  // redirects when its path actually matches the current location. Returning a
  // bare <Redirect> here would fire for every disallowed route at once — and
  // these routes live under <Layout>, not a <Switch>, so that produced an
  // endless redirect loop as soon as any route was disallowed.
  return (
    <Route
      {...props}
      render={(routeProps) =>
        isAllowed ? <Component {...routeProps} /> : <Redirect to={redirectTo} />
      }
    />
  );
};

const AppProcess = () => {
  const licenceCheck = useSelector((state) => state?.users.licenceCheck);
  const user = useSelector((state) => state?.users.user);
  const [currentComponent, setCurrentComponent] = useState(null);

  useEffect(() => {
    if (
      licenceCheck?.theme !== "cloud_model" ||
      user?.role === "ADMIN" ||
      user?.role === "SUPERADMIN"
    ) {
      setCurrentComponent(<AppProcessLocal />);
    } else {
      setCurrentComponent(<AppProcessCloud />);
    }
  }, [licenceCheck, user]);

  return currentComponent;
};

const AppProcessLocal = () => {
  const user = useSelector((state) => state?.users.user);
  // Admin-only pages must not even render for a normal user. This is a
  // convenience guard — the backend independently rejects the requests.
  const isPrivileged = user && (user.role === "ADMIN" || user.role === "SUPERADMIN");
  const { theme } = useTheme();
  const location = useLocation();
  const mustChangePassword = Boolean(user?.must_change_password);

  return (
    <ErrorBoundary>
      <CustomScrollbar>
        <CssBaseline />
        {theme || !user ? (
          <div>
            {/* A user who still has the installation password may not use any
                other page until it is changed. The pathname check keeps this
                from re-firing once we are already on /change-password (see the
                redirect-loop note on ProtectedRoute above). */}
            {user && mustChangePassword && location.pathname !== "/change-password" && (
              <Redirect to="/change-password" />
            )}
            <Switch>
              <ProtectedRoute
                path="/"
                exact
                component={SignIn}
                isAllowed={!user}
                redirectTo="/login"
              />
              <ProtectedRoute
                path="/login"
                exact
                component={SignIn}
                isAllowed={user}
                redirectTo="/newdash"
              />
              <ProtectedRoute
                path="/login/ldap"
                exact
                component={LdapSignIn}
                isAllowed={!user}
                redirectTo="/newdash"
              />
              <ProtectedRoute
                path="/forgot-password"
                component={ForgotPassword}
                isAllowed={!user}
                redirectTo="/newdash"
              />
              <ProtectedRoute
                path="/reset-password/:token"
                component={ResetPassword}
                isAllowed={!user}
                redirectTo="/newdash"
              />
              <ProtectedRoute
                path="/change-password"
                exact
                component={ChangePassword}
                isAllowed={Boolean(user && mustChangePassword)}
                redirectTo={user ? "/newdash" : "/login"}
              />
              <ProtectedRoute
                path="/log-window/:type"
                component={LogWindow}
                isAllowed={user}
                redirectTo="/newdash"
              />
              <Layout>
                <ProtectedRoute
                  path="/docs/api"
                  exact
                  component={ApiDocu}
                  isAllowed={user}
                  redirectTo="/newdash"
                />
                <ProtectedRoute
                  path="/newdash"
                  exact
                  component={NewDash}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/dashboard"
                  exact
                  component={Dashboard}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/phishbox"
                  exact
                  component={PhishBox}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/hunterbox"
                  exact
                  component={HunterBox}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/watermark-decoder"
                  exact
                  component={WatermarkDecoder}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/historical-analysis"
                  exact
                  component={RunningAnalysis}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/statistics"
                  exact
                  component={Statistics}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/analysis-reports"
                  component={AnalysisReportsWrapper}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/report-export"
                  component={ReportExport}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/report-pdf"
                  component={ReportPDF}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/threat-hunter-report-export"
                  component={ThreatHunterReportExport}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/threat-hunter-report-pdf"
                  component={ThreatHunterReportPDF}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/android-report-export"
                  component={AndroidReportExport}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/android-report-pdf"
                  component={AndroidReportPDF}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/remote-connection"
                  component={RemoteConnection}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/reports"
                  component={Reports}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/user-accounts"
                  component={UserAccounts}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/data-retention"
                  component={DataRetention}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/backup-and-restore"
                  component={DumpAndRestore}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/notifications"
                  component={Notifications}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/auto-submission"
                  component={AutoSubmission}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/ldap"
                  component={Ldap}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/publicapi"
                  component={PublicApi}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/core-servers"
                  component={CoreServers}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/custom-signatures/:signatureType"
                  exact={true}
                  component={CustomSignatures}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/update-scheduler"
                  exact={true}
                  component={UpdateScheduler}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/phishbox"
                  exact={true}
                  component={PhishboxSettings}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/settings/llm"
                  exact={true}
                  component={LlmSettings}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/system-info"
                  component={SystemInfo}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/integration-market"
                  component={IntegrationMarket}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/products"
                  component={Products}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/user-profile"
                  component={UserProfile}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute path="/cdr" component={Cdr} isAllowed={user} redirectTo="/" />
                <ProtectedRoute
                  path="/ImapEmail"
                  component={ImapEmail}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/sharepoint"
                  component={FileShare}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/proxy"
                  component={ProxyWeb}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute path="/tapper" component={TapWeb} isAllowed={user} redirectTo="/" />
                <ProtectedRoute
                  path="/submissions"
                  component={Endpoint}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/fileshare"
                  component={WinShare}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/postfixemail"
                  component={PostfixEmail}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/outlook"
                  component={OutlookAddIn}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/usbtransfer"
                  component={Email}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/agentstatus"
                  component={AgentStatus}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/agentinstallation"
                  component={AgentInstallation}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/threat-hunter/dashboard"
                  component={ThreatHunterDashboard}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/threat-reports"
                  component={ThreatReports}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/yara-results"
                  component={YaraResults}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/network-detections"
                  component={NetworkDetections}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                {/* <ProtectedRoute
                  path="/threat-hunter"
                  component={ThreatHunterDetections}
                  isAllowed={user}
                  redirectTo="/"
                /> */}
                <ProtectedRoute
                  path="/iocs/dashboard"
                  component={IocDashboard}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/iocs/urls"
                  component={Urls}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/iocs/hosts-and-domains"
                  component={DomainsAndIps}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/iocs/hashes"
                  component={Hashes}
                  isAllowed={user}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/mailgateway/dashboard"
                  component={MailGatewayDashboard}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/mailgateway/analyzed-emails"
                  component={AnalyzedEmails}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/mailgateway/blocked-emails"
                  component={BlockedEmails}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/mailgateway/unblocked-emails"
                  component={UnblockedEmails}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/mailgateway/transfer-logs"
                  component={TransferLogs}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/mailgateway/dynamic-phishing-emails"
                  component={DynamicPhishingEmails}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                {/* <ProtectedRoute
                  path="/fsa/cdr"
                  component={FsaCdr}
                  isAllowed={user}
                  redirectTo="/"
                /> */}
                {/* <ProtectedRoute
                  path="/fsa/applications"
                  component={FsaApplications}
                  isAllowed={user}
                  redirectTo="/"
                /> */}
                <ProtectedRoute
                  path="/containers"
                  component={ContainerServicesPage}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
                <ProtectedRoute
                  path="/logs"
                  component={Logs}
                  isAllowed={isPrivileged}
                  redirectTo="/"
                />
              </Layout>
            </Switch>
          </div>
        ) : (
          <div className="Backdrop" style={{ backgroundColor: "black" }}>
            <div className="loaderdefault" />
          </div>
        )}

        <Footer />
        <Notifier />
      </CustomScrollbar>
    </ErrorBoundary>
  );
};

const AppProcessCloud = () => {
  const user = useSelector((state) => state?.users.user);

  return (
    <ErrorBoundary>
      <CustomScrollbar>
        <CssBaseline />
        <Switch>
          <ProtectedRoute path="/login" component={Login} isAllowed={!user} redirectTo="/" />
          <ProtectedRoute path="/signup" component={SignUp} isAllowed={!user} redirectTo="/" />

          <ProtectedRoute
            path="/forgot-password"
            component={ForgotPW}
            isAllowed={!user}
            redirectTo="/"
          />
          <CloudLayout>
            <ProtectedRoute path="/" exact component={Home} isAllowed={true} />
            <ProtectedRoute path="/pricing" component={Pricing} isAllowed={true} redirectTo="/" />
            <ProtectedRoute
              path="/submission-list"
              exact
              component={SubmissionList}
              isAllowed={true}
            />
            <ProtectedRoute
              path="/reset-password/:token"
              component={ResetPassword}
              isAllowed={!user}
              redirectTo="/"
            />
            <ProtectedRoute
              path="/docs/api"
              exact
              component={ApiDocu}
              isAllowed={user}
              redirectTo="/dashboard"
            />
            <ProtectedRoute
              path="/analysis-reports"
              component={AnalysisReportsWrapper}
              isAllowed={user}
              redirectTo="/"
            />
            <ProtectedRoute
              path="/report-export"
              component={ReportExport}
              isAllowed={user}
              redirectTo="/"
            />
            <ProtectedRoute
              path="/report-pdf"
              component={ReportPDF}
              isAllowed={user}
              redirectTo="/"
            />
            <ProtectedRoute
              path="/android-report-export"
              component={AndroidReportExport}
              isAllowed={user}
              redirectTo="/"
            />
            <ProtectedRoute
              path="/android-report-pdf"
              component={AndroidReportPDF}
              isAllowed={user}
              redirectTo="/"
            />
            <ProtectedRoute path="/reports" component={Reports} isAllowed={user} redirectTo="/" />
            <ProtectedRoute
              path="/profile"
              component={CloudProfile}
              isAllowed={user}
              redirectTo="/"
            />
          </CloudLayout>
        </Switch>
        <CloudFooter />
        <Notifier />
      </CustomScrollbar>
    </ErrorBoundary>
  );
};

const App = () => {
  const dispatch = useDispatch();
  const { theme, setTheme } = useTheme();

  const isBackendServiceConnected = useSelector(
    (state) => state.container.isBackendServiceConnected,
  );

  useEffect(() => {
    setTheme(loadFromLocalStorage("theme"));
    dispatch(themeRequest(theme));
    dispatch(licenceCheckRequest());
    dispatch(RequestBackendServiceConnected());
  }, [dispatch]);

  useEffect(() => {
    if (isBackendServiceConnected) return;

    const intervalId = setInterval(() => {
      dispatch(RequestBackendServiceConnected());
    }, 24000);

    return () => clearInterval(intervalId);
  }, [isBackendServiceConnected, dispatch]);

  if (isBackendServiceConnected) return <AppProcess />;
  else
    return (
      <div style={{ backgroundColor: "var(--content-background)", width: "100%", height: "100vh" }}>
        <Backdrop show={true} message="Waiting to connect backend service" />
      </div>
    );
};

export default App;
